import { makeStyles } from 'tss-react/mui';

const useStylesLimitedPageContainer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  limitedPageContainerActive: {
    maxWidth: 1980,
    [theme.breakpoints.up('xl')]: {
      marginRight: 'auto !important',
    },
  },
}));

export default useStylesLimitedPageContainer;
